import { Heading } from 'components/src/typography';
import { Maybe } from 'types/generated';
import { HeadingType } from '@/types';

type Props = {
  heading?: HeadingType;
  color?: Maybe<string>;
  textColor?: Maybe<string>;
  containerClasses?: string;
  classes?: string;
  headingVariant: 'xl' | 'large' | 'medium' | 'small' | 'xs' | 'mobile-xl';
};

const TextWithInlineColor = ({
  heading,
  color = 'black-100',
  textColor = 'black-100',
  containerClasses = '',
  classes = '',
  headingVariant,
}: Props) => {
  const italicsColor = `text-${color}`;

  return (
    heading && (
      <div className={`${containerClasses} break-words`}>
        <Heading variant={headingVariant} classes={`${classes}`}>
          {heading.content.map((c) =>
            c.content.map((item, index) => {
              const hasAnotherColor = item.marks.some((i) => i.type.includes('italic'));
              return (
                <span key={index} className={hasAnotherColor ? italicsColor : `text-${textColor}`}>
                  {item.value}
                </span>
              );
            })
          )}
        </Heading>
      </div>
    )
  );
};
export default TextWithInlineColor;
